import RaisedButton from 'material-ui/RaisedButton';
import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as actions from '../../actions/actions.jsx';
import creditcardlogo from '../../images/credit-cards-vector-icon-.jpg';
import services from '../../services/allservices.jsx';
import Loader from '../loader/loader.jsx';
import LoaderSmall from "../loader/loadersmall.jsx";
import UserModal from './regmodal.jsx';
import GusetNavbar from '../navigation/guestnavbar';
import { getClientId, getClientSecret,buildClientHeader } from "../../../src/utils/clientAuth.js";
import uuidv4 from 'uuid/v4';
const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    activationcardState: state.getactivationcardReducer.activationcardState
})
const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    storeCardNumber(cardNumber) {
        dispatch(
            actions.storeCardDetail(cardNumber)
        )
    },
    getactivation(state) {

        dispatch(
            actions.getactivationcardAction(state)

        )
    },
})


const JSEncrypt = window.JSEncrypt
class CardNumber extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardVerificationDone: false,
            mobileVerificationDone: false,
            mobiledisable: true,
            disabled: true,
            expiryDone: false,
            cardVerified: false,
            verification: false,
            rederFeedback: false,
            mobilecardVerified: false,
            mobileverification: false,
            mobilerederFeedback: false,
            mobile: '',
            open: false,
            loader: false,
            title: "Invalid Card Number",
            openModal: false,
            cardType: "",
        }
        this.storeCard = this.storeCard.bind(this)
    }

    componentDidMount() {
        // React.findDOMNode(this.refs.item.focus())
        if (localStorage.getItem('landingTabs') === 'cardNo') {
            document.getElementById("cardNumber").focus()
        }
        this.props.fetchPublicKey(false)

    }
    handlediable = () => {


        if (this.state.verification === true && this.state.mobileverification === true) {


            this.setState({
                // disabled: false

            })
        }
        else {
            this.setState({
                disabled: true
            })
        }


    }

    handleClose = () => {

        document.getElementById("myModal").style.display = "none"

    }
    storeCard() {
        // this.props.history.push('/activate-card')
        this.setState({
            disabled: false

        })
        // const state = {
        //     cardNumber: this.state.cardNumber,
        //     applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
        // }
        if (this.state.cardType === "A") {


            this.setState({
                openModal: true
            })

        }
        else if (this.state.cardType === "G" || this.state.cardType === "R") {
            this.props.history.push('/activate-card')
        }
        else {
            this.setState({
                disabled: true

            })
            // toast.error('Please fill valid data'), {
            //     position: "top-right",
            //     draggablePercent: 60,
            //     autoClose: 3000,
            //     hideProgressBar: false,
            //     closeOnClick: true,
            //     pauseOnHover: true,
            //     draggable: false
            // };
            setTimeout(function () {
                window.location.reload(1);
            }, 3000);
        }
        // _this.props.history.push('/activate-card')




        // else {

        //     if (cardno.length != 0) {
        //         this.setState({ cardVerified: true, rederFeedback: false })

        //         if (publicKey.status === 200) {
        //             const public_Key = publicKey.body.publickey;
        //             let encrypt = new JSEncrypt();
        //             encrypt.setPublicKey(public_Key);
        //             let encrypted = encrypt.encrypt(cardno);
        //             this.props.storeCardNumber(encrypted)
        //             localStorage.setItem("cardNumber", encrypted)
        //             this.setState({ cardNumber: encrypted })
        //             const state = {
        //                 cardNumber: encrypted,
        //                 applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
        //             }

        //             fetch(services.verify_card, {
        //                 method: 'POST',
        //                 headers: new Headers({
        //                     'Content-Type': 'application/json',
        //                 }),
        //                 body: JSON.stringify(state)
        //             })
        //                 .then(response => {
        //                     if (response.status === 200 || response.status === 201) {
        //                         response.json().then(function (object) {
        //                             _this.setState({ cardVerified: false, rederFeedback: true, verification: true, cardVerificationDone: true, })

        //                             let mobile = object.mobileNumber
        //                             let res = mobile.substring(mobile.length - 4, mobile.length);

        //                             _this.setState({ mobile: res })
        //                             localStorage.setItem("status", object.cardStatus)
        //                             let step = 1
        //                             JSON.stringify(localStorage.setItem("step", step))
        //                             _this.props.history.push('/activate-card')
        //                         })
        //                     } else {

        //                         _this.setState({ cardVerified: false, rederFeedback: true, loader: false })
        //                         toast.error(response.headers.get('message'), {
        //                             position: "top-right",
        //                             draggablePercent: 60,
        //                             autoClose: 3000,
        //                             hideProgressBar: false,
        //                             closeOnClick: true,
        //                             pauseOnHover: true,
        //                             draggable: false
        //                         });

        //                     }
        //                 })
        //         }
        //     }
        //     else {
        //         toast.error(('please enter card number'), {
        //             position: "top-right",
        //             draggablePercent: 60,
        //             autoClose: 3000,
        //             hideProgressBar: false,
        //             closeOnClick: true,
        //             pauseOnHover: true,
        //             draggable: false
        //         });
        //     }

        // }



        if (this.state.cardType === "G" || this.state.cardType === "R") {
            JSON.stringify(localStorage.setItem('step', 0))
            this.props.history.push('/activate-card')
        }

    }
    handleOldUser = () => {
        this.setState({
            existingUser: "yes",
            stepIndex: 1,
        }, () => {
            JSON.stringify(localStorage.setItem('step', 1))
            localStorage.setItem('existingUser', 'yes')
            setTimeout(() => {
                this.props.history.push('/activate-card')
            }, 500)

        })
    }
    handleNewUser = () => {
        this.setState({
            existingUser: "no",
            stepIndex: 1,
        }, () => {
            JSON.stringify(localStorage.setItem('step', 1))
            localStorage.setItem('existingUser', 'no')
            setTimeout(() => {
                this.props.history.push('/activate-card')
            }, 500)
        })
    }
    async checkCardNumber(e) {
        let _this = this
        let string = e.target.value;
        const cardNumber = string.replace(/-/g, "");
        const actualCardNumber = cardNumber.replace(/_/g, "");


        JSON.stringify(localStorage.setItem('cdNo', actualCardNumber))
        const { publicKey } = this.props
        if (actualCardNumber.length >= 16) {
      //  now validation will be via verify card api below code not needed for prod or test

            // if(!actualCardNumber.startsWith('48138122')){
            //     toast.error(('Invalid Card Number'), {
            //         position: "top-right",
            //         draggablePercent: 60,
            //         autoClose: 3000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: false
            //     });
            //     return ;
            // }

            this.setState({ cardVerified: true, rederFeedback: false, cardno: cardNumber, mobiledisable: true, title: "Invalid Card Number" })

            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                let encrypted = encrypt.encrypt(cardNumber);
                this.props.storeCardNumber(encrypted)
                localStorage.setItem("cardNumber", encrypted)
                this.setState({ cardNumber: encrypted })
                const state = {
                    cardNumber: encrypted,
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
                }
                let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
                    let gvvid = getClientId();
                    let traceId = getClientId();

    
                await fetch(plink + services.verify_card, {
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'clientId': gvvid,
                        'clientSecret': getClientSecret(gvvid,actualCardNumber),
                        'X-Trace-Id': traceId,
                        'X-Client-APP':buildClientHeader(),   
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201) {

                            response.json().then(function (object) {

                                _this.setState({
                                    cardVerified: false, rederFeedback: true, verification: true, mobiledisable: false, title: '', cardVerificationDone: true,
                                    cardStatus: object.cardStatus
                                })
                                let dob = object.specialDate
                                JSON.stringify(localStorage.setItem('dob', dob))
                                localStorage.setItem("cardType", object.cardType)
                                if (object.cardType !== "A") {


                                    let dArr = dob.split("-");  // ex input "2010-01-18"


                                    var res = dArr[2].substring(0) + dArr[1].substring(0);

                                    _this.setState({
                                        dob: res,
                                        cardType: object.cardType,
                                        disabled: true,
                                    })
                                }
                                else {

                                    localStorage.setItem("cardType", _this.state.cardType)
                                    _this.setState({
                                        disabled: false,
                                        cardType: object.cardType,
                                    })
                                }

                                let state = {
                                    cardNumber: object.cardNumber,
                                    expiryDate: object.expiryDate,
                                    firstName: object.firstName,
                                    lastName: object.lastName,
                                }
                                localStorage.setItem("accountId", object.accountId)
                                localStorage.setItem("expiry", object.expiryDate)
                                localStorage.setItem("cardTypes", _this.state.cardType)
                                localStorage.setItem("cardProgram", object.cardProgram)
                                localStorage.setItem("existingUser", object.accountIdExist)
                                _this.props.getactivation(state)
                            })

                        }
                        // else if (response.status === 422) {
                        //     response.json()
                        //     .then(json => {
                        //         let message = json.message? json.message: response.headers.get('message')
                        //     //document.getElementById('setpassword').style.display = "block"
                        //     toast.error(message, {
                        //         position: "top-right",
                        //         autoClose: 3000,
                        //         hideProgressBar: false,
                        //         closeOnClick: true,
                        //         pauseOnHover: true,
                        //         draggable: true,
                        //         draggablePercent: 60
                        //     })
                        // })}
                        else {
                            _this.setState({ cardVerified: false, rederFeedback: true, verification: false, mobiledisable: true, title: "Invalid Card Number" })
                            // eslint-disable-next-line
                            toast.error(response.headers.get('message')), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            };

                        }
                    })
            }
        }
        else {
            if (actualCardNumber.length !== 0)
                toast.error(('Invalid Card Number'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
        }

    }
    checkMobileNumber(e) {



        if (e.target.value !== "") {

            this.setState({ mobilecardVerified: true, mobilerederFeedback: false, disabled: false, })
            if (e.target.value === this.state.dob) {

                this.setState({ mobilecardVerified: false, mobilerederFeedback: true, mobileverification: true, mobileVerificationDone: true, })
            } else {
                this.setState({ mobilecardVerified: false, mobilerederFeedback: true, mobileverification: false, disabled: true })
            }
        }
    }
    handleModal(e) {
        if (e) { e.preventDefault() }
        this.setState({ open: !this.state.open })
    }

    closeUserModal = () => {
        this.setState({
            openModal: false
        })
    }
    render() {
        const { cardVerified, loader, verification, rederFeedback, mobilecardVerified, mobileverification, mobilerederFeedback } = this.state


        return (
            <div>
                {this.state.openModal && <UserModal
                    open={this.state.openModal}
                    onClose={this.closeUserModal}
                    handleOld={this.handleOldUser}
                    handleNew={this.handleNewUser}
                />}

                {loader ? <div>
                    <Loader />
                </div> :
                    <div style={{ paddingTop: 10 }} className="" >
                        <GusetNavbar />
                        <div className="container" style={{ minHeight: '500px', backgroundColor: 'transparent' }}>
                            <div className="col-md-6 card-images nopaddingleft" >

                                <div className="simstitle mt-5">THE CARD <br />WITH CHOICE</div>
                                <div className="simsrect"> </div>
                                <div className='mt-5 mb-4'>
                                    <a className='appbutton ml-2'> Download App </a>
                                </div>

                            </div>
                            <div className="col-12">
                                <div className="logmainheading mt-3">Sign in to Your Card Account</div>
                            </div>
                            <div className="cardno">
                                <div className="col-sm-12">
                                    <div className="row input-group" >
                                        <div className="offset-md-2 col-sm-1 group-icon" >
                                            <img src={creditcardlogo} alt="" />
                                            {/* <i className="fa fa-credit-card-alt text-dark " aria-hidden="true"></i> */}
                                        </div>
                                        <div className="col-sm-6" style={{ marginLeft: "15px", padding: "8px" }}>

                                            <div className="group">
                                                <InputMask mask="9999-9999-9999-9999" onChange={this.handlediable.bind(this)} autoComplete='none' placeholder="1234-1234-1234-1234" onBlur={this.checkCardNumber.bind(this)}
                                                    id="cardNumber" ref="item" />
                                                <span className="highlight"></span>
                                                <span className="bar"></span>
                                                <label>Enter Card Number</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            {cardVerified ? <LoaderSmall /> : null}
                                            {rederFeedback ? <div className="feedback">
                                                {verification ? <i className="fa fa-check" aria-hidden="true" style={{ color: "green", marginLeft: "3px" }}></i> :
                                                    <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                            </div> : null}

                                            {/*  */}
                                        </div>
                                    </div>

                                    {(this.state.cardType === "G" || this.state.cardType === "R") ?
                                        <div className="row">
                                            <div className="offset-md-2 col-sm-1 group-icon">
                                                <i className="fa fa-birthday-cake " aria-hidden="true" style={{ fontSize: "34px", right: "-7px" }}></i>
                                            </div>
                                            <div className="col-sm-6">
                                                <label style={{ fontSize: "14px", marginLeft: "10px" }}>Date Of Birth </label>
                                                <div className="group" style={{ marginTop: "0px" }}>

                                                    <InputMask mask="9999" placeholder="DDMM" title={this.state.title} autoComplete='none' readOnly={this.state.mobiledisable} onChange={this.handlediable} onBlur={this.checkMobileNumber.bind(this)}
                                                        id="phonenumber" />


                                                </div>

                                                {/* <div className="group">
                                                <InputMask mask="99/99"
                                                    name="d"
                                                    id="expiry"
                                                    ref="item"
                                                    // onChange={this.onChangeExpiry.bind(this)}
                                                    placeholder="MM/YY"
                                                    onBlur={this.handleExpiry.bind(this)}
                                                    // disabled={this.state.exipryField}
                                                    defaultValue={this.state.actualExpiryNumber}
                                                />
                                                <span className="highlight"></span>
                                                <span className="bar"></span>
                                                <label>Expiry Date</label>                           
                                            </div> */}
                                            </div>


                                            <div className="col-sm-2">
                                                {mobilecardVerified ? <LoaderSmall /> : null}
                                                {mobilerederFeedback ? <div className="feedback">
                                                    {mobileverification ? <i className="fa fa-check" aria-hidden="true" style={{ color: "green" }}></i> :
                                                        <i className="fa fa-times" aria-hidden="true" style={{ color: "red" }}></i>}
                                                </div> : null}
                                            </div>
                                            {/* <div className="col-sm-1 group-icon">
                                                <i className="fa fa-calendar text-dark " aria-hidden="true" ></i>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="group">
                                                    <InputMask mask="99/99" placeholder="12/18" />
                                                    <span className="highlight"></span>
                                                    <span className="bar"></span>
                                                    <label>Expiration Date</label>
                                                </div>
                                            </div> */}
                                        </div>
                                        :
                                        <div>
                                        </div>
                                    }
                                    <div className="row input-group">
                                        <div className="offset-md-5 ">
                                            <RaisedButton
                                                disabled={this.state.disabled}
                                                label="Submit"
                                                className="btn-std"
                                                backgroundColor="#FFCE39"
                                                labelColor="#115876"
                                                buttonStyle={{ borderRadius: 50 }}
                                                style={{ borderRadius: 50 }}
                                               

                                                onClick={this.storeCard}
                                            />
                                            <Link to='/login' className='simplelink' style={{ marginLeft: '15px' }}> Sign in to your card account  <i className="fas fa-arrow-alt-circle-right ml-2"></i></Link>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
            </div>

        );
    }
}

// CardNumber.propTypes = {
//     publicKey: PropTypes.object,
//     keyRecieved: PropTypes.bool
// };
CardNumber.defaultProps = {
    keyRecieved: false
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CardNumber));


// WEBPACK FOOTER //
// ./src/components/register/cardnumber.jsx